import React from 'react';
import store from '../../store'
import PropTypes from 'prop-types';
import connectWithStore from '../../hocs/connectWithStore';
import EventFilter from '../controls/filters/event_filter';
import MonthFilter from '../controls/filters/month_filter';
import SeasonFilter from '../controls/filters/season_filter';
import TournamentFilter from '../controls/filters/tournament_filter';
import { new_game_path, new_training_path } from 'routes';
import { seasonSet, setSeasonAndReload, setTournamentAndReload } from '../controls/filters/filters_actions';

class EventHeader extends React.Component {
  constructor(props) {
    super(props);
    props.seasonSet(0);
  }

  // Tournaments are loaded once for every season and tagged with the seasons they
  // have games in; filter them down to the currently selected season.
  tournamentsForSeason = (tournaments, seasonId) => {
    if (!seasonId) return tournaments;
    return tournaments.filter(t => (t.season_ids || []).includes(seasonId));
  }

  handleSeasonChange = (selectedSeason) => {
    // Reconcile the tournament with the new season: keep it if it still has games in
    // the season, otherwise fall back to "All Tournaments" (0). Dispatch both together
    // so a single reload fires with a consistent season + tournament pair.
    const { init, selectedTournament } = this.props;
    const validTournaments = this.tournamentsForSeason(init.tournaments, selectedSeason);
    const stillValid = selectedTournament === 0 || validTournaments.some(t => t.id === selectedTournament);
    const nextTournament = stillValid ? selectedTournament : 0;
    this.props.setSeasonAndReload(selectedSeason, nextTournament);
  }

  handleTournamentChange = (selectedOption) => {
    this.props.setTournamentAndReload(selectedOption.value);
  }

  render() {
    const user = store.getState().current_user;
    const locale = user.locale;
    const t_controls = this.props.init.t_controls.controls;
    const { init, selectedSeason, selectedTournament } = this.props;
    const filteredTournaments = this.tournamentsForSeason(init.tournaments, selectedSeason);

    return(
      <article style={{marginBottom: '2em'}}>
        <div style={{display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap', gap: '1em'}}>
          <span style={{zIndex: 100}}>
            <ul className="list-inline list-inline-xs list-inline-middle">
              <EventFilter eventTypes={init.eventTypes}/>
              <MonthFilter months={init.months}/>
              <TournamentFilter
                tournaments={filteredTournaments}
                tournamentSet={this.handleTournamentChange}
                currentTournament={selectedTournament || 0}
                t_controls={t_controls}
                allIncluded={true}
              />
              <SeasonFilter
                seasons={init.seasons}
                seasonSet={this.handleSeasonChange}
                currentSeason={selectedSeason || 0 }
                t_controls={t_controls}
                allIncluded={false}
              />
            </ul>
          </span>
          { user?.admin &&
          <span>
            <ul className="list-inline list-inline-xs list-inline-middle">
              <li>
                <a href={`${new_game_path({ locale: locale })}`} className="button button-sm button-primary">{`${t_controls.new_game}`}</a>
              </li>
              <li>
                <a href={`${new_training_path({ locale: locale })}`} className="button button-sm button-primary">{`${t_controls.new_tranining}`}</a>
              </li>
            </ul>
          </span>
          }
        </div>
      </article>
    )
  }
}

EventHeader.propTypes = {
  init: PropTypes.shape({
    eventTypes: PropTypes.array.isRequired,
    months: PropTypes.array.isRequired,
    seasons: PropTypes.array.isRequired,
    tournaments: PropTypes.array.isRequired,
    t_controls: PropTypes.object.isRequired,
  }),
  seasonSet: PropTypes.func.isRequired,
  setSeasonAndReload: PropTypes.func.isRequired,
  setTournamentAndReload: PropTypes.func.isRequired,
  selectedSeason: PropTypes.number,
  selectedTournament: PropTypes.number,
}

const mapStateToProps = state => ({
  selectedSeason: state.events.selectedSeason,
  selectedTournament: state.events.selectedTournament,
});

const mapDispatchToProps = {
  seasonSet,
  setSeasonAndReload,
  setTournamentAndReload,
};

export default connectWithStore(
  mapStateToProps,
  mapDispatchToProps
)(EventHeader);
